const base_api_url = "https://api-pools-upgrade.navig8pool.com";
export const environment = {
  BASE_API_URL: base_api_url,
  production: false,
  URL_CMS: "https://staging-cms.navig8pool.com/",
};
